<template>
    <button class="btn show btn-sm btn-outline-primary" :class="{active: isSelected}" @click.stop.prevent="toggle(favorite.id, $event)">
      <template v-if="favorite.description">{{favorite.description}}</template>
      <template v-else>{{favorite.name}}</template>
    </button>
</template>

<script>

export default {
  name: 'Favorite',
  props: {
    favorite: Object
  },
  computed: {
    isSelected () {
      return this.$store.state.selectedFolder.includes(this.favorite.id)
    }
  },
  methods: {
    toggle (id, evt) {
      if (evt.shiftKey) {
        if (!this.isSelected) {
          this.$store.commit('setSelectedFolder', id)
        } else {
          this.$store.commit('deleteSelectedFolder', id)
        }
      } else {
        this.$store.commit('clearSelectedFolder', [id])
      }
    }
  }
}
</script>
